const setupAutocompleteSx = {
  width: "100%",
  "& .MuiOutlinedInput-root": {
    minHeight: 44,
    paddingTop: "4px",
    paddingBottom: "4px",
    paddingLeft: "12px",
    paddingRight: "44px",
    borderRadius: "10px",
    backgroundColor: "#fafaf9",
    "& fieldset": {
      borderColor: "#d6d3d1",
      borderWidth: "1px",
    },
    "&:hover fieldset": {
      borderColor: "#a8a29e",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#ea580c",
      borderWidth: "1px",
    },
  },
  "& .MuiAutocomplete-input": {
    padding: "6px 4px !important",
    fontSize: "14px",
  },
  "& .MuiAutocomplete-endAdornment": {
    right: 8,
    top: "50%",
    transform: "translateY(-50%)",
  },
  "& .MuiAutocomplete-popupIndicator, & .MuiAutocomplete-clearIndicator": {
    padding: 2,
  },
};

export default setupAutocompleteSx;
